import React from 'react';
import { Text } from '@carnica/ui-kit';
import { withAutoMetric } from '@beef/auto-metric';
import classNames from 'classnames/bind';

import { NewsContainer, NewsItemProps, NewsLabelsList } from 'pages/News/SharedComponents';
import { formatDate } from 'pages/News/NewsPage/utils/date';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

interface LatestNewsItemProps {
  item: NewsItemProps;
}

const _LatestNewsItem: React.FC<LatestNewsItemProps> = ({ item }) => {
  return (
    <NewsContainer href={item.href}>
      <Text color="secondary" variant="caption-medium">
        {formatDate(item.date)}
      </Text>
      <Text className={cx('news-title')} rows={3} tagName="h3" truncate variant="headline-small">
        {item.title}
      </Text>
      <NewsLabelsList labels={item.labels} />
    </NewsContainer>
  );
};

export const LatestNewsItem = withAutoMetric.Element((props: LatestNewsItemProps) => ({
  name: 'LatestNewsItem',
  news_title: props.item.title,
}))(_LatestNewsItem);
